import '@tiptap/extension-text-style';
import { Mark, mergeAttributes } from '@tiptap/core';
import Colorizers from "../../../../colorizer/Colorizers.js";
const Color = Mark.create({
  name: 'color',
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return {
      colorizer: {
        default: null,
        parseHTML: element => element.getAttribute('data-colorizer'),
        renderHTML: attributes => {
          return {
            'data-colorizer': attributes.colorizer
          };
        }
      }
    };
  },
  parseHTML() {
    return [{
      tag: 'color',
      getAttrs: node => {
        return node.hasAttribute('data-colorizer') ? node.getAttribute('data-colorizer') : null;
      }
    }];
  },
  renderHTML({
    HTMLAttributes
  }) {
    let attrs = {
      // eslint-disable-next-line max-len
      style: 'border-top: 1px solid red; border-right: 1px solid green; border-bottom: 1px solid blue; border-left: 1px solid violet;'
    };
    if (!this.editor?.options?.editable) {
      let val;
      try {
        val = HTMLAttributes['data-colorizer'] ? JSON.parse(HTMLAttributes['data-colorizer']) : null;
      } catch (err) {}
      if (val) {
        const {
          object,
          context
        } = this.editor?.options?.editorProps || {};
        const color = Colorizers.getColor(val, object, context);
        attrs = {
          style: `color: ${color};`
        };
      }
    }
    return ['color', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, attrs), 0];
  },
  addCommands() {
    return {
      setColor: color => ({
        commands
      }) => {
        let dataValue;
        try {
          dataValue = JSON.stringify(color);
        } catch (err) {}
        return commands.setMark(this.name, {
          colorizer: dataValue
        });
      },
      unsetColor: () => ({
        commands
      }) => {
        return commands.unsetMark(this.name);
      }
    };
  }
});
export default {
  id: 'Rich.Text.Editor.Extension.Color',
  extension: Color
};